import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Typography, Divider, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { authApi } from '../../services/auth';
import { useAuthStore } from '../../stores/authStore';
import { ROUTES } from '../../config/routes';

const { Text } = Typography;

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { setAuth } = useAuthStore();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: { email: string; password: string; remember: boolean }) => {
    setLoading(true);
    try {
      const response = await authApi.login({ email: values.email, password: values.password });
      setAuth(response.data);
      message.success('登录成功');
      navigate(ROUTES.DASHBOARD);
    } catch (error) {
      // 错误已在request拦截器中处理
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      name="login"
      initialValues={{ remember: true }}
      onFinish={handleSubmit}
      size="large"
    >
      <Form.Item
        name="email"
        rules={[
          { required: true, message: '请输入邮箱' },
          {
            validator: (_: unknown, value: string) => {
              if (!value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('请输入有效的邮箱地址'));
            },
          },
        ]}
      >
        <Input
          prefix={<UserOutlined />}
          placeholder="邮箱"
          autoComplete="email"
        />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[{ required: true, message: '请输入密码' }]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="密码"
          autoComplete="current-password"
        />
      </Form.Item>

      <Form.Item>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>记住我</Checkbox>
          </Form.Item>
          <Link to={ROUTES.FORGOT_PASSWORD}>忘记密码?</Link>
        </div>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block loading={loading}>
          登录
        </Button>
      </Form.Item>

      <Divider>或</Divider>

      <div style={{ textAlign: 'center' }}>
        <Text type="secondary">
          还没有账号? <Link to={ROUTES.REGISTER}>立即注册</Link>
        </Text>
      </div>
    </Form>
  );
};
